import * as NextConstants from "../../src/constants/next"
import React from "react"
import { MatchAPI } from "../../src/apis/MatchAPI"
import { RSS, SEO } from "../../src/types/next.js"
import { getNavigationProps } from "@components/Navigation/getNavigationProps"
import InferNextPropsType from "infer-next-props-type"
import { CompetitionAPI } from "../../src/apis/CompetitionAPI"
import { SeasonAPI } from "../../src/apis/SeasonAPI"
import { CompetitionSeasonAPI } from "../../src/apis/CompetitionSeasonAPI"
import { GroupAPI } from "../../src/apis/GroupAPI"
import { simplifyNews } from "utils/news"
import { LocalizedMatchWithSimplifiedNews } from "types/match"
import BetNews from "@components/Betting/BetNews"
import { CalciocomConfigsAPI } from "../../src/apis/CalciocomConfigsAPI"
import { simplifyMatches } from "types/matches/response.dto"

export default function PredictionsOddPage({
  navigationProps,
  matches,
  pageNum,
  pages,
  teamStandings,
  seasonSlug,
  homeData,
}: InferNextPropsType<typeof getStaticProps>) {
  return (
    <BetNews
      matches={matches}
      landings={[]}
      pageNum={pageNum}
      pages={pages}
      teamStandings={teamStandings}
      navigationCompetitions={navigationProps.competitions}
      seasonSlug={seasonSlug}
      competitionName={"Tutti"}
      homeData={homeData}
      competitionSlug={null}
    />
  )
}
export async function getStaticProps() {
  try {
    const pageNum = 1
    const pageSize = 5
    const title = `Quote e Pronostici Scommesse`

    const seo: SEO = {
      title: title,
      description: `Le quote ed i pronostici sulle scommesse calcistiche e le statistiche di tutte le partite. Segui i nostri esperti per pronostici di calcio sicuri`,
      keywords: ["Pronostici"],
      canonicals: [`/pronostici`],
      index: true,
      follow: true,
    }

    const rss: RSS = {
      type: "scommesse",
    }

    const [matches, competitionIds, navigationProps, homeData] = await Promise.all([
      MatchAPI.getPredictionsPaginated({
        pageSize: pageSize,
        currentPage: pageNum,
      }),
      CompetitionAPI.getCompetitionIds("italia-serie-a"),
      getNavigationProps(),
      CalciocomConfigsAPI.getCalciocomConfigHomeData(),
    ])

    const competition = await CompetitionAPI.getCompetition(competitionIds.id)
    const seasons = await SeasonAPI.getSeasonsByCompetitionId(competition.id)
    const season = seasons[0]
    const competitionSeasonId = await CompetitionSeasonAPI.getIdByCompetitionIdAndSeasonId(competition.id, season.id)
    const groups = await SeasonAPI.getPhaseGroups(competitionSeasonId)
    const teamStandings = await GroupAPI.getTeamBettingParameterStandings(groups[0].id)

    const simplifiedMatches: LocalizedMatchWithSimplifiedNews[] = matches.data.map((match) => {
      return {
        match: simplifyMatches(match.match),
        news: simplifyNews(match.news),
      }
    })

    return {
      props: {
        title,
        seo,
        rss,
        pageNum,
        teamStandings,
        next: "/pronostici/2",
        seasonSlug: season.calciocomSlug,
        pages: matches.pages >= 10 ? 10 : matches.pages,
        showSearchInput: false,
        matches: simplifiedMatches,
        navigationProps: navigationProps,
        showCenterColumn: false,
        homeData,
      },
      revalidate: NextConstants.REVALIDATE,
    }
  } catch (error) {
    console.error(error)
    return {
      notFound: true,
    }
  }
}
